import * as Sentry from '@sentry/react'
import { SENTRY_ENABLE_LOGS, SENTRY_ENVIRONMENT } from 'config'

const sentryOptions: Parameters<typeof Sentry.init>[0] = {
  dsn: 'https://57c8049c67a91c9e1ae3198bba83d76b@o4508994071756800.ingest.us.sentry.io/4510992874274816',
  enabled: SENTRY_ENABLE_LOGS,
  enableLogs: SENTRY_ENABLE_LOGS,
  environment: SENTRY_ENVIRONMENT,
}

Sentry.init(sentryOptions)
